"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Implementation of the 'icon' markup element.
 * A div HTML element is created and the class
 * lto-icon is added to allow CSS manipulations.
 *
 * @see {@link IRenderable}
 */
var Icon = /** @class */ (function () {
    function Icon(position) {
        this.position = position;
    }
    Icon.prototype.render = function () {
        var icon = document.createElement('div');
        icon.classList.add('lto-icon', "lto-" + this.position);
        return icon;
    };
    return Icon;
}());
exports.Icon = Icon;
